@if (avverkningsanmalan) {
  <div>
    <div class="validation-container">
      <rask-virkeskop-validation-message
        entityType="avverkningsanmalan"
        [entityGuid]="atgard.guid">
      </rask-virkeskop-validation-message>
    </div>
    <div>
      <rask-radiobutton-group
        #ansvarigTyp
        aid="vk-atgard-anmalanansvar"
        label="Ansvarar för avverkningsanmälan/-ansökan"
        [buttons]="radioButtonsAnsvarTyp"
        [ngModel]="getAvverkningsanmalanAnsvarigTyp()"
        [disabled]="kontraktReadonly || atgard.isUtfort"
        [onBeforeChange]="onBeforeChangeAvverkningsanmalanAnsvarigTyp"
        (change)="changeAvverkningsanmalanAnsvarigTyp(ansvarigTyp.value)">
      </rask-radiobutton-group>
    </div>
    @if (avverkningsanmalan.typ !== avverkningsanmalanTyp.leverantor) {
      <div>
        <rask-radiobutton-group
          #anmalanTyp
          aid="vk-atgard-anmalan-skogstyp"
          label="Skogstyp för anmälan"
          [ngModel]="getAnmalanSkogsTyp()"
          (change)="changeAnmalanSkogsTyp(anmalanTyp.value)"
          [buttons]="radioButtonsAnmalanSkogstyp"
          [disabled]="kontraktReadonly || atgard.isUtfort || !skogstypCanChange()">
        </rask-radiobutton-group>
      </div>
    }
    @if (avverkningsanmalan.typ !== avverkningsanmalanTyp.leverantor) {
      <div>
        <div class="d-flex">
          @if (anmalanStatusMessage) {
            <rask-button
              color="secondary"
              (click)="openAvverkningsanmalanWebb()"
              [disabled]="!canSend || kontraktReadonly || atgard.isUtfort"
              ngbPopover="{{anmalanStatusMessage}}" triggers="mouseenter:mouseleave"
              popoverTitle="Status avverkningsanmälan"
            icon="fas fa-info-circle">Avverkningsanmälan</rask-button>
          }
          @if (!anmalanStatusMessage) {
            <rask-button
              color="secondary"
              [disabled]="!canSend || kontraktReadonly || atgard.isUtfort"
            (click)="openAvverkningsanmalanWebb()">Avverkningsanmälan</rask-button>
          }
        </div>
        <div>
          <rask-radiobutton-group
            class="w-100"
            aid="vk-atgard-anmalantyp"
            label="Typ av anmälan"
            [buttons]="[{ key: false, value: 'Anmälan' }, { key: true, value: 'Ansökan' }]"
            [ngModel]='avverkningsanmalan.ansokan'
            [disabled]="true">
          </rask-radiobutton-group>
          <div class="d-flex">
            <rask-textmultiline
              label="Anmälan utförd"
              value="{{avverkningsanmalan.godkantDatum | date:'yyyy-MM-dd' }}"
              [nullIndicator]="true">
            </rask-textmultiline>
            <rask-textmultiline
              label="Avverkning får starta"
              value="{{avverkningsanmalan.avverkningFarStartaDatum | date:'yyyy-MM-dd' }}"
              [nullIndicator]="true">
            </rask-textmultiline>
            <rask-textmultiline
              label="Giltig till"
              value="{{avverkningsanmalan.giltigtTillDatum | date:'yyyy-MM-dd' }}"
              [nullIndicator]="true">
            </rask-textmultiline>
            <rask-checkbox
              text="Dispensansökan"
              [ngModel]="avverkningsanmalan.dispens"
              [disabled]="true">
            </rask-checkbox>
          </div>
        </div>
      </div>
    }
    @if (avverkningsanmalan.typ === avverkningsanmalanTyp.leverantor) {
    <div>
        <rask-button
        color="secondary"
        [disabled]="true">Avverkningsanmälan</rask-button>
    </div>
      <div>
        <rask-radiobutton-group
          aid="vk-atgard-anmalantyp"
          label="Typ av anmälan"
          [buttons]="[{ key: false, value: 'Anmälan' }, { key: true, value: 'Ansökan' }]"
          [(ngModel)]='avverkningsanmalan.ansokan'
          [disabled]="kontraktReadonly || atgard.isUtfort"
          (change)="changeAvverkningsanmalanTyp()">
        </rask-radiobutton-group>
      </div>
      <div class="d-flex">
        <rask-datepicker
          aid="vk-atgard-avverkning-godkant-datum"
          label="Anmälan utförd"
          [allowInvalidInput]="true"
          [(ngModel)]="avverkningsanmalan.godkantDatum"
          [disabled]="kontraktReadonly || atgard.isUtfort"
          [maxDate]="maxGodkantDatum"
          (change)="avverkningsanmalanGodkantDatumChange()">
        </rask-datepicker>
        <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq-->
        @if (avverkningsanmalan.godkantDatum != null) {
          @if ((avverkningsanmalan.ansokan || avverkningsanmalan.dispens)) {
            <rask-datepicker
              aid="vk-atgard-avverkning-far-starta-datum"
              label="Avverkning får starta"
              [allowInvalidInput]="true"
              [(ngModel)]="avverkningsanmalan.avverkningFarStartaDatum"
              [disabled]="kontraktReadonly || atgard.isUtfort"
              [minDate]="getMinDateFarStarta()"
              [maxDate]="getMaxDateFarStarta()"
              (change)="avverkningsanmalanFarStartaDatumChange($event)">
            </rask-datepicker>
          }
          @if (!avverkningsanmalan.ansokan && !avverkningsanmalan.dispens) {
            <rask-textmultiline
              label="Avverkning får starta"
              value="{{avverkningsanmalan.avverkningFarStartaDatum | date:'yyyy-MM-dd' }}">
            </rask-textmultiline>
          }
        } @else {
          <rask-textmultiline
            label="Avverkning får starta"
            value="">
          </rask-textmultiline>
        }
        <rask-textmultiline
          label="Giltig till"
          value="{{avverkningsanmalan.giltigtTillDatum | date:'yyyy-MM-dd'}}">
        </rask-textmultiline>
        <rask-checkbox text="Dispensansökan" [(ngModel)]="avverkningsanmalan.dispens"
          [disabled]="avverkningsanmalan.ansokan || kontraktReadonly || atgard.isUtfort"
        (change)="avverkningsanmalanDispensChange()"></rask-checkbox>
      </div>
      <div class="avslag-button-container">
        @if (avverkningsanmalan.godkantDatum) {
          <rask-button [disabled]="kontraktReadonly || atgard.isUtfort" color="secondary" (click)="avslag()" negative>
          Avslag</rask-button>
        }
      </div>
    }
    @if (avverkningsanmalan.avslagDatum) {
      <div>
        <rask-span size="5">Avslag registrerat: {{avverkningsanmalan.avslagDatum | date:'yyyy-MM-dd'}}</rask-span>
      </div>
    }
  </div>
} @else {
  <rask-busy-spinner size="3"></rask-busy-spinner>
}

